export class Outline {
  coordinates: Array<Array<Array<number>>>;
  cropType: string;
  id: number;
  mef: string;
  size: number;
}